import { createAction, props } from '@ngrx/store';

import {
  GetReplaceVehicleResponse,
  QuickQuoteRequest,
  ReplaceVehiclePLPCPayload,
  SubmitOnlineBindRequestModel
} from '@amfam/policy/models';
import { ApiStatus, PaymentScheduleItem } from '@amfam/shared/models';
import {
  ANSNotification,
  InternalEmail,
  TemplatedEmail
} from '@amfam/shared/utility/shared-services';

export const getQuickQuote = createAction(
  '[Replace Vehicle Quick Quote Data] Get Quick Quote',
  props<{ quickQuoteRequest: QuickQuoteRequest }>()
);

export const getQuote = createAction(
  '[Replace Vehicle Quote Data] Get Quick Quote',
  props<{ quoteRequest: ReplaceVehiclePLPCPayload }>()
);

export const getQuickQuoteSuccess = createAction(
  '[Replace Vehicle Quick Quote Data] Get Quick Quote Success',
  props<{ response: GetReplaceVehicleResponse }>()
);

export const getQuoteSuccess = createAction(
  '[Replace Vehicle Quick Quote Data] Get Quote Success',
  props<{ response: GetReplaceVehicleResponse }>()
);

export const getQuickQuoteFailed = createAction(
  '[Replace Vehicle Quick Quote Data] Get Quick Quote Failed',
  props<{ error: ApiStatus }>()
);

export const quickQuoteSendCustomerEmail = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Send Customer Email ',
  props<{ email: TemplatedEmail }>()
);

export const quickQuoteSendCustomerEmailSuccess = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Send Customer Email Success'
);

export const quickQuoteSendCustomerEmailFailed = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Send Customer Email Failed',
  props<{ status: ApiStatus }>()
);

export const quickQuoteSendToAgentCustomerEmail = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Send To Agent Customer Email ',
  props<{ email: TemplatedEmail }>()
);

export const quickQuoteSendToAgentCustomerEmailSuccess = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Send To Agent Customer Email Success'
);

export const quickQuoteSendToAgentCustomerEmailFailed = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Send To Agent Customer Email Failed',
  props<{ status: ApiStatus }>()
);

export const quickQuoteSendToAgentEmail = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Send To Agent Email ',
  props<{ email: InternalEmail }>()
);

export const quickQuoteSendToAgentEmailSuccess = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Send To Agent Email Success'
);

export const quickQuoteSendToAgentEmailFailed = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Send To Agent  Email Failed',
  props<{ status: ApiStatus }>()
);

export const ansNotification = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote ANS Notification ',
  props<{ notification: ANSNotification }>()
);

export const ansNotificationSuccess = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote ANS Notification Success'
);

export const ansNotificationFailed = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote ANS Notification Failed',
  props<{ status: ApiStatus }>()
);

export const quickQuoteEmailAgentOnError = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Email Agent On Error ',
  props<{ email: InternalEmail }>()
);

export const quickQuoteEmailAgentOnErrorSuccess = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Email Agent On Error Success'
);

export const quickQuoteEmailAgentOnErrorFailed = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Email Agent On Error Failed',
  props<{ status: ApiStatus }>()
);

export const quickQuoteEmailCustomerOnError = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Email Customer On Error ',
  props<{ email: TemplatedEmail }>()
);

export const quickQuoteEmailCustomerOnErrorSuccess = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Email Customer On Error Success'
);

export const quickQuoteEmailCustomerOnErrorFailed = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote Email Customer On Error Failed',
  props<{ status: ApiStatus }>()
);

export const ansNotificationOnError = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote ANS Notification On Error ',
  props<{ notification: ANSNotification }>()
);

export const ansNotificationOnErrorSuccess = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote ANS Notification On Error Success'
);

export const ansNotificationOnErrorFailed = createAction(
  '[Replace Vehicle Quick Quote Data] Quick Quote ANS Notification On Error Failed',
  props<{ status: ApiStatus }>()
);

export const bindQuickQuote = createAction(
  '[Replace Vehicle Quick Quote Data] Bind Quick Quote',
  props<{ payload: SubmitOnlineBindRequestModel }>()
);

export const bindQuote = createAction(
  '[Replace Vehicle Quote Data] Bind Quote',
  props<{ payload: SubmitOnlineBindRequestModel }>()
);

export const bindQuoteSuccess = createAction(
  '[Replace Vehicle  Quote Data] Bind Quote Success',
  props<{ response: ApiStatus }>()
);

export const bindQuoteSuccessAnalytics = createAction(
  '[Replace Vehicle  Quote Data] Bind Quote Success',
  props<{ payload: { workOrderNumber: string; vehicleId: string } }>()
);

export const bindQuoteFail = createAction(
  '[Replace Vehicle  Quote Data] Bind Quote Fail',
  props<{ status: ApiStatus }>()
);

export const bindQuickQuoteSuccess = createAction(
  '[Replace Vehicle Quick Quote Data] Bind Quick Quote Success',
  props<{ response: ApiStatus }>()
);

export const bindQuickQuoteFail = createAction(
  '[Replace Vehicle Quick Quote Data] Bind Quick Quote Fail',
  props<{ status: ApiStatus }>()
);

export const resetExceptionANSError = createAction(
  '[Replace Vehicle Quick Quote Data] Reset Exception ANS Error'
);

export const resetANSError = createAction('[Replace Vehicle Quick Quote Data] Reset ANS Error');

export const resetQuickQuoteError = createAction(
  '[Replace Vehicle Quick Quote Data] Reset Quick Quote Error'
);

export const resetQuickQuote = createAction('[Replace Vehicle Quick Quote Data] Reset Quick Quote');

export const replaceVehicleAgentEmailOnCancelProcess = createAction(
  '[Replace Vehicle Quote] Agent Email Cancel Process',
  props<{ email: InternalEmail }>()
);

export const replaceVehicleCustomerEmailOnCancelProcess = createAction(
  '[Replace Vehicle Quote] Customer Email Cancel Process',
  props<{ email: TemplatedEmail }>()
);

export const replaceVehicleANSOnCancelProcess = createAction(
  '[Replace Vehicle Quote] ANS Cancel Process',
  props<{ notification: ANSNotification }>()
);

export const loadFuturePayments = createAction(
  '[Replace Vehicle Summary Component] Load Future Payments',
  props<{ policyNumber: string; submissionId: string }>()
);

export const loadFuturePaymentsSuccess = createAction(
  '[Replace Vehicle Future Payment Effect] Load Future Payments Success',
  props<{ paymentSchedule: PaymentScheduleItem[] }>()
);

export const loadFuturePaymentsFailed = createAction(
  '[Replace Vehicle Future Payment Effect] Load Future Payments Failed'
);

export const notfiyOnBindQuoteSuccess = createAction(
  '[Replace Vehicle Data Bind Quote Effect] Notify on Bind',
  props<{ payload: SubmitOnlineBindRequestModel }>()
);

export const ansNotificationOnBind = createAction(
  '[Replace Vehicle Quick Quote Data Notify Agent Effect] Quote ANS Notification On Bind',
  props<{ notification: ANSNotification }>()
);

export const ansNotificationOnBindSuccess = createAction(
  '[Replace Vehicle Quick Quote Data ANS Notification Effect] Quote ANS Notification On Bind Success'
);
export const ansNotificationOnBindFailed = createAction(
  '[Replace Vehicle Quick Quote Data ANS Notification Effect] Quote ANS Notificatio On Bind Failed',
  props<{ status: ApiStatus }>()
);

export const emailAgentOnBind = createAction(
  '[Replace Vehicle Quick Quote Data Notify Agent Effect] Quote Email Agent On Bind',
  props<{ email: InternalEmail }>()
);

export const emailAgentOnBindSuccess = createAction(
  '[Replace Vehicle Quick Quote Data Email Agent Effect] Quote Email Agent On Bind Success'
);
export const emailAgentOnBindFailed = createAction(
  '[Replace Vehicle Quick Quote Data Email Agent Effect] Quote Email Agent On Bind Failed'
);

export const emailCustomerOnBind = createAction(
  '[Replace Vehicle Data Bind Quote Effect] Email Customer on Bind',
  props<{ email: TemplatedEmail }>()
);

export const emailCustomerOnBindSuccess = createAction(
  '[Replace Vehicle Quick Quote Data Email Customer Effect] Quote Email Customer On Bind Success'
);
export const emailCustomerOnBindFailed = createAction(
  '[Replace Vehicle Quick Quote Data Email Customer Effect] Quote Email Customer On Bind Failed',
  props<{ status: ApiStatus }>()
);
